<template>
  <div class="search-info">
    <SearchHeader
      type="integral"
      @search="onSearch"
      @focus="emptybool=false"
      v-model="input"
      placeholder="搜索课程或图书"
    ></SearchHeader>
    <div v-if="input!=''">
      <div class="fixed-wrap" v-if="showList">
        <div class="tabs">
          <div class="tab-header">
            <div
              class="tab-header-item"
              :class="{'tab-header-item-active':tab==1}"
              @click="changeTab(1)"
            >好课推荐</div>
            <div
              class="tab-header-item"
              :class="{'tab-header-item-active':tab==2}"
              @click="changeTab(2)"
            >热门图书</div>
          </div>
        </div>
      </div>
      <van-list class="list" v-model="loading" :finished="finished" @load="onLoad">
        <IntegralItem v-for="item in list" :key="item.id" :item="item"></IntegralItem>
      </van-list>
      <empty :empty_type="empty_type" v-if="showList&&list.length==0"></empty>
    </div>
  </div>
</template>
<script>
import SearchHeader from "@/components/SearchHeader";
import IntegralItem from "@/components/integral/IntegralItem";
import empty from "@/components/Empty";
export default {
  name: "IntegralStoreSearch",
  components: { empty, SearchHeader, IntegralItem },
  data() {
    return {
      name: "",
      searchbool: false,
      emptybool: false,
      placeholder: "请输入内容",
      empty_type: {
        name: "暂无搜索结果"
      },
      tab: 1,
      list: [],
      limit: 10,
      page: 1,
      loading: false,
      finished: true,
      showList: false,
      input: ""
    };
  },
  computed: {
    point_name() {
      if(this.$store.state.config){
        return this.$store.state.config.point_info.point_name
      } else{
        return '';
      };
    }
  },
  created() {
    document.title = this.point_name + "商城搜索";
  },
  watch: {
    point_name(val) {
      document.title = val + "商城搜索";
    }
  },
  methods: {
    async changeTab(tab) {
      this.tab = tab;
      await this.goSearch();
    },
    async onSearch(key) {
      this.name = key;
      await this.goSearch();
    },
    async goSearch() {
      if (this.finished) {
        this.page = 0;
        this.finished = false;
      } else {
        this.page = 1;
        this.list = [];
        await this.getList();
      }
    },
    async getList() {
      let data = await this.$http.get("/api/integral/shop/index", {
        type: this.tab,
        name: this.name,
        page: this.page,
        limit: this.limit
      });
      this.loading = false;
      this.showList = true;
      if (data.list.length == 0) {
        this.finished = true;
        if (this.page == 1) {
          this.emptybool = true;
          this.list = [];
        }
        return;
      }
      if (this.page == 1) {
        this.list = data.list;
      } else {
        this.list = this.list.concat(data.list);
      }
      this.emptybool = false;
    },
    onLoad() {
      this.page++;
      this.getList();
    }
  }
};
</script>
<style scoped lang="scss">
.search-info {
  padding-bottom: 80px;
  .search-status {
    margin: 20px;
    li {
      height: 102px;
      padding-left: 18px;
      line-height: 102px;
      font-size: 30px;
      color: #333;
      text-align: left;
      &:not(:last-child) {
        border-bottom: 0.5px solid rgba(234, 234, 234, 1);
      }
    }
  }
  .index-item-page {
    background: #f8f8f8;
  }
}
.fixed-wrap {
  position: relative;
  padding-top: 30px;
  margin-bottom: 42px;
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
    box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.2);
    .search {
      top: 0;
    }
  }
}
.tabs {
  .tab-header {
    display: flex;
  }
  .tab-header-item {
    flex-grow: 1;
    text-align: center;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 56, 55, 1);
    line-height: 40px;
    position: relative;
  }
  .tab-header-item-active {
    color: $theme_color;
    &::after {
      content: "";
      width: 22px;
      height: 6px;
      background: $theme_color;
      border-radius: 4px;
      position: absolute;
      bottom: -6px;
      left: 50%;
      margin-left: -11px;
    }
  }
}
.list {
  padding: 0 30px;
  &.fixed {
    padding-top: 166px;
  }
}
</style>
